import React from 'react';

import { v9 } from '../v9';

import PartnerSelect from './PartnerSelect';

import type { RevenueConfiguration } from './RiskTierStep';

interface PartnerCoBrandingStepProps {
	configuration: RevenueConfiguration;
	onUpdate: (updates: Partial<RevenueConfiguration>) => void;
	// The partner linked to this Schedule A (Settings › Partners); '' is none.
	partnerId: string;
	onPartnerChange: (partnerId: string) => void;
}

const PartnerCoBrandingStep: React.FC<PartnerCoBrandingStepProps> = ({
	configuration,
	onUpdate,
	partnerId,
	onPartnerChange,
}) => {
	const share = configuration.partner_revenue_share_percent;
	const shareInvalid = share != null && (share < 0 || share > 100);

	return (
		<div>
			<div className={v9.wizardTitle}>
				<h3 className={v9.wizardH3}>Partner Co-Branding</h3>
				<p className={v9.wizardP}>
					The partner's logo and name show on proposals priced with this
					Schedule A
				</p>
			</div>

			<div className="mx-auto max-w-[960px] space-y-4">
				<div>
					<label htmlFor="revenuePartner" className={v9.label}>
						Partner
					</label>
					<PartnerSelect
						id="revenuePartner"
						value={partnerId}
						onChange={onPartnerChange}
						emptyLabel="Select a partner"
					/>
					<p className={v9.help}>
						Add partners in Settings › Partners. A partner's statements are
						priced on its own Schedule A.
					</p>
				</div>

				<div>
					<label htmlFor="partnerShare" className={v9.label}>
						Partner revenue share
					</label>
					<div className="relative">
						<input
							id="partnerShare"
							type="number"
							min={0}
							max={100}
							step="0.01"
							value={share ?? ''}
							onChange={(e) =>
								onUpdate({
									partner_revenue_share_percent:
										e.target.value === '' ? null : Number(e.target.value),
								})
							}
							className={`${v9.input} pr-12 ${shareInvalid ? 'border-red-300 bg-red-50' : ''}`}
						/>
						<span className="absolute right-3 top-2 text-sm text-gray-500">
							%
						</span>
					</div>
					{shareInvalid ? (
						<p className="mt-1 text-xs text-red-700">
							Enter a share from 0 to 100.
						</p>
					) : (
						<p className={v9.help}>The partner's percentage of revenue</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default PartnerCoBrandingStep;
